import { render } from "./CreateBuildingView.vue?vue&type=template&id=6351c429"
import script from "./CreateBuildingView.vue?vue&type=script&lang=js"
export * from "./CreateBuildingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__